var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CustomSelect',{staticClass:"w-100",attrs:{"inputId":"rolePicker","inputLabel":"نقش کاربر","value":_vm.value,"customOptions":_vm.rolesList},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }